import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentImagesIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#E9FEF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.6602 18.4385L28.6802 22.6185C27.8402 26.2285 26.1802 27.6885 23.0602 27.3885C22.5602 27.3485 22.0202 27.2585 21.4402 27.1185L19.7602 26.7185C15.5902 25.7285 14.3002 23.6685 15.2802 19.4885L16.2602 15.2985C16.4602 14.4485 16.7002 13.7085 17.0002 13.0985C18.1702 10.6785 20.1602 10.0285 23.5002 10.8185L25.1702 11.2085C29.3602 12.1885 30.6402 14.2585 29.6602 18.4385Z",
			stroke: "#0DC277",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.0603 27.3916C22.4403 27.8116 21.6603 28.1616 20.7103 28.4716L19.1303 28.9916C15.1603 30.2716 13.0703 29.2016 11.7803 25.2316L10.5003 21.2816C9.22034 17.3116 10.2803 15.2116 14.2503 13.9316L15.8303 13.4116C16.2403 13.2816 16.6303 13.1716 17.0003 13.1016C16.7003 13.7116 16.4603 14.4516 16.2603 15.3016L15.2803 19.4916C14.3003 23.6716 15.5903 25.7316 19.7603 26.7216L21.4403 27.1216C22.0203 27.2616 22.5603 27.3516 23.0603 27.3916Z",
			stroke: "#0DC277",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.6396 16.5312L25.4896 17.7613",
			stroke: "#0DC277",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6602 20.3984L22.5602 21.1384",
			stroke: "#0DC277",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDocumentImagesIcon;
